const shutdown = (inElectron()) ? global.require('electron-shutdown-command') : false;

// Shutdown handling class
export class Shutdown {

	constructor(secondsToHold) {
		this.onClick("#shutdown");
		this.downTimeStamp = null;
		this.secondsToHold = secondsToHold || 15;
		this.interval = null;
	}

	onClick(el) {
		$(el).on("mousedown touchstart", (e) => {
			e.preventDefault();
			this.downTimeStamp = Date.now();

			this.clearInterval();
			this.interval = setInterval(() => {
				if (Date.now() - this.downTimeStamp > this.secondsToHold * 1000) {
					this.shutdown();
				}
			}, 1000);

			$(document).one("mouseup touchend", (e) => {
				e.preventDefault();
				this.clearInterval();
			})
		})
	}

	shutdown() {
		console.log("shutdown")
		if (shutdown) {
			shutdown.shutdown({
				force: true
			})
		}
	}

	clearInterval() {
		if (this.interval) {
			clearInterval(this.interval);
			this.interval = null;
		}
	}
}
